import React from "react"

const CardContentWrapper: React.FC<{ children: object }> = ({ children }) => (
  <div className="text-site-blue-dark relative flex flex-1 flex-col p-4">
    {children}
  </div>
)

export default CardContentWrapper
